// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__WM+Wr","tooltip-container":"styles_tooltip-container__+5caH","key":"styles_key__cxnkW","keys":"styles_keys__p6dPB"};